import userService from "services/user.service";
import userProfile from "services/user.profile";
import {
  MEMBERS_LIST,
  TEAM_MEMBERS,
  SET_MESSAGE,
  EDIT_MEMBER,
  BAMBOOHR_EMPLOYEES,
  ADD_MEMBER,
  SCHEDULES,
  EMAILS,
  ROLES,
  HAS_ACCOUNT,
} from "./types";

export const membersList = (activeOnly, directEmployeesOnly) => (dispatch) => {
  return userService.getTeamMembersList(activeOnly, directEmployeesOnly).then(
    ({ data }) => {
      dispatch({
        type: MEMBERS_LIST,
        payload: data,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};

export const membersListOddo = (activeOnly, directEmployeesOnly, originUrl, token) => (dispatch) => {
  return userService.getTeamMembersListOddo(activeOnly, directEmployeesOnly, originUrl, token).then(
    ({ data }) => {
      dispatch({
        type: MEMBERS_LIST,
        payload: data.employees,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};

export const teamMembers = (dispatch) => {
  return userProfile.getProfileMembers().then(
    ({ data }) => {
      dispatch({
        type: TEAM_MEMBERS,
        payload: data,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};

export const editMember = (id, data) => (dispatch) => {
  return userProfile.changeProfileMember(id, data).then(
    ({ data }) => {
      dispatch({
        type: EDIT_MEMBER,
        payload: data,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};

export const addMember = (data) => (dispatch) => {
  return userProfile.addProfileMember(data).then(
    ({ data }) => {
      dispatch({
        type: ADD_MEMBER,
        payload: data,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};

export const bamboohrEmployees = (dispatch) => {
  return userProfile.getBamboohrEmployees().then(
    ({ data }) => {
      dispatch({
        type: BAMBOOHR_EMPLOYEES,
        payload: data,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};

export const schedulesList = (dispatch) => {
  return userProfile.getSchedules().then(
    ({ data }) => {
      dispatch({
        type: SCHEDULES,
        payload: data,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};

export const emailsList = (dispatch) => {
  return userProfile.getEmails().then(
    ({ data }) => {
      dispatch({
        type: EMAILS,
        payload: data,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};

export const rolesList = (dispatch) => {
  return userProfile.getRoles().then(
    ({ data }) => {
      dispatch({
        type: ROLES,
        payload: data,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};

export const accountState = (id) => (dispatch) => {
  return userProfile.getAccountStatus(id).then(
    ({ data }) => {
      dispatch({
        type: HAS_ACCOUNT,
        payload: data,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};
